var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.16667H16.25V8.75H14.5833V11.25H16.25V10.8333H17.5V11.6667C17.5 12.125 17.125 12.5 16.6667 12.5H14.1667C13.7083 12.5 13.3333 12.125 13.3333 11.6667V8.33333C13.3333 7.875 13.7083 7.5 14.1667 7.5H16.6667C17.125 7.5 17.5 7.875 17.5 8.33333V9.16667ZM6.66667 8.33333V12.5H5.41667V11.25H3.75V12.5H2.5V8.33333C2.5 7.875 2.875 7.5 3.33333 7.5H5.83333C6.29167 7.5 6.66667 7.875 6.66667 8.33333ZM5.41667 8.75H3.75V10H5.41667V8.75ZM11.25 10C11.7083 10 12.0833 10.375 12.0833 10.8333V11.6667C12.0833 12.125 11.7083 12.5 11.25 12.5H7.91667V7.5H11.25C11.7083 7.5 12.0833 7.875 12.0833 8.33333V9.16667C12.0833 9.625 11.7083 10 11.25 10ZM9.16667 8.75V9.375H10.8333V8.75H9.16667ZM10.8333 10.625H9.16667V11.25H10.8333V10.625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbc);
export default __webpack_public_path__ + "static/media/abc.463086b0fdc7f5e24195bc5637d9dd7f.svg";
export { ForwardRef as ReactComponent };